// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hPoPU","right":"styles_right__yN1EW","contents":"styles_contents__J8Y-h","active":"styles_active__e2QQk"};